<template>
  <div class="background-curriculum">
    <b-container>
      <b-row>
        <b-col
          class="text-left mt-3"
          v-for="level in levels"
          :key="level.id"
          cols="12"
          md="4"
        >
          <h4>{{ level.title }}</h4>
          <p v-html="level.description"></p>
          <router-link
            :to="{
              name: 'curriculumshow',
              params: { id: level.id }
            }"
          >
            <!-- <b-button variant="success">더 알아보기</b-button> -->
          </router-link>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      levels: [
        {
          id: 1,
          title: "코딩 배우기",
          description: "Apple은 Everyone Can Code (누구나 즐겁게 코딩, ECC)라는 이름으로 모든 사람이 쉽고 재밌게 코딩에 접근 할 수 있도록 교육 컨텐츠를 만들었습니다. 플레이그라운드 코딩배우기 1&2와 언플러그드 활동을 통해 계산적 사고를 함양할 수 있습니다."
            .split("\n")
            .join("<br />")
        },
        {
          id: 2,
          title: "App 기획자 UX 디자인 과정",
          description: "자신의 아이디어를 코딩 없이 간단하게 구현해  \n 볼 수 있으며,  애플리케이션의 기획과 디자인 과정을 \n 이해하게 됩니다. 코더스하이는 그동안 애플의 \n  인터페이스 가이드라인을 준수한 교육 과정으로 다양한 현장 경험을   축적해 왔습니다."
            .split("\n")
            .join("<br />")
        },
        {
          id: 0,
          title: "iOS 앱 디자인과 개발과정",
          description: "iOS 앱 디자인과 앱 개발과정을 통해 \n 앱의 기획, 디자인, 앱을 개발하는 일련의 과정을 \n 학습할 수 있습니다.  코더스하이의 교육 과정은 누구에게나 열려 있으며, 애플에서 인증한 교육자들이 \n  iOS 앱개발 강의를 진행합니다."
            .split("\n")
            .join("<br />")
        }
      ]
    };
  }
};
</script>

<style scoped>
.background-curriculum {
  background-color: #f5f5f5;
}
a {
  text-decoration: none;
  color: inherit;
}
</style>
